import { useCustomerRecapsData } from "@acto/taskpane/core/data-access/customers/useCustomerRecapsData";
import { CompletedAppointmentsSidePanel } from "../CompletedAppointmentsSidePanel/CompletedAppointmentsSidePanel";
import { CompletedAppointmentsSidePanelSkeleton } from "../CompletedAppointmentsSidePanel/CompletedAppointmentsSidePanelSkeleton";
import { usePeriodLabel } from "../../DateRangeSelector/DateRangeSelector";
import { PeriodOption, DateRange } from "../../DateRangeSelector/types";
import { periodToDateRange } from "../../../utils/periodToDateRange";
import { Note } from "@acto/taskpane/core/domain";
import { useNotes } from "@acto/taskpane/core/data-access/notes/useNotes";

interface CustomerRecapsSidePanelProps {
  customerName: string;
  clientId: string;
  selectedPeriod?: PeriodOption;
  selectedCustomDateRange?: DateRange;
  onRecapClick?: (note: Note | undefined, clientId: string) => void;
}

export const CustomerRecapsSidePanel = ({
  customerName,
  clientId,
  selectedPeriod = PeriodOption.LAST_12_MONTHS,
  selectedCustomDateRange,
  onRecapClick,
}: CustomerRecapsSidePanelProps) => {
  const periodLabel = usePeriodLabel(selectedPeriod, selectedCustomDateRange);
  const dateRange = periodToDateRange(selectedPeriod, selectedCustomDateRange);

  const {
    data: customerNotes,
    hasNextPage,
    fetchNextPage,
    isFetching,
  } = useNotes({
    clientId,
    dateRange,
    limit: 10,
  });

  const data = useCustomerRecapsData(customerNotes, customerName);

  if (!data) {
    return <CompletedAppointmentsSidePanelSkeleton />;
  }

  const dataWithPeriod = {
    ...data,
    dateRange: periodLabel,
  };

  const onSelectRecap = (noteId: string | null) => {
    const selectedNote = customerNotes?.find((note) => note.id === noteId);
    onRecapClick?.(selectedNote, clientId);
  };

  return (
    <CompletedAppointmentsSidePanel
      data={dataWithPeriod}
      onAppointmentClick={onSelectRecap}
      hasMore={hasNextPage}
      onLoadMore={fetchNextPage}
      isLoadingMore={isFetching}
    />
  );
};
